import type { TFunction } from 'i18next';

export type MeasurementUnit = 'in' | 'mm' | 'cm';

export const DEFAULT_MEASUREMENT_UNIT: MeasurementUnit = 'in';

export const MEASUREMENT_UNITS: readonly MeasurementUnit[] = ['in', 'cm', 'mm'] as const;

export const MEASUREMENT_UNIT_TRANSLATIONS: Record<MeasurementUnit, { key: string; fallback: string }> = {
  in: { key: 'units.inches', fallback: 'in' },
  cm: { key: 'units.centimeters', fallback: 'cm' },
  mm: { key: 'units.millimeters', fallback: 'mm' },
};

export const translateMeasurementUnitLabel = (t: TFunction, unit: MeasurementUnit): string => {
  const { key, fallback } = MEASUREMENT_UNIT_TRANSLATIONS[unit];
  return t(key, fallback);
};
